import useDeviceMedia from "@hooks/useDeviceMedia"
import clsx from "clsx"
import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import { usePropertyStore } from "../../../store/propertyStore"
import {
  AmentiesCheckbox,
  AmentiesSliderModalSelect,
  AreaSlider,
  BedroomRangeSelect,
  BuildingTypeModalSelect,
  BuyRentTab,
  DeveloperSelect,
  FurnishedCheckbox,
  OffplanStatusSelect,
  PriceRangeSelect,
  SearchButton,
} from "../../filterElements"
import "./FilterModal.scss"
import FilterModalBody from "./FilterModalBody"
import { navigate } from "gatsby"
import MultiSelectInput from "@components/SearchResults/MultiSelectInput/MultiSelectInput"

const FilterModal = ({ isOpen, setIsOpen, isPropertyPage, buyRent, isOffplan }) => {
  const { isTablet } = useDeviceMedia()
  const { statusType, setStatusType } = usePropertyStore(
    (state) => ({
      statusType: state.statusType,
      setStatusType: state.setStatusType
    })
  )
  const pType = usePropertyStore((state) => state.pType)
  const clearFilters = usePropertyStore((state) => state.clearFilters)
  const pDepartment = usePropertyStore((state) => state.pDepartment)
  const setcrmId = usePropertyStore((state) => state.setcrmId)
  const crmId = usePropertyStore((state) => state.crmId)
  const isOffPlan = pDepartment === "new_developments"
  const [isvalidate, setValidate] = useState(false)
  const goRedirect = () => {
    setValidate(true)
    if (crmId) {
      window.open(process.env.GATSBY_SITE_URL + "/" + crmId, '_blank', 'noopener')
    }
  }
  return (
    isPropertyPage ?
      <Modal
        show={isOpen}
        onHide={() => setIsOpen(false)}
        dialogClassName={clsx(
          "modal-search-filter",
          isPropertyPage && "property-modal"
        )}
        backdropClassName={clsx(
          "modal-search-filter-backdrop",
          isPropertyPage && "property-modal"
        )}
        fullscreen={isTablet}
      >
        <Modal.Header closeButton>
          <h2 className="title">{isOffPlan ? "More Filter" : "Property Search"}</h2>
        </Modal.Header>
        <Modal.Body>

          <div className="filter-section">
            {/* {!isOffPlan && (
              <>
                <BuyRentTab />
                <div className="divider" />
              </>
            )} */}
            {isTablet ? (
              <>
              <div className="modal-filter-item">
               <h3 className="modal-filter-title">Location</h3>
               <div className="modal-filter-section">
                <MultiSelectInput />
                </div>
                </div>
                <div className="divider" />
                <BuildingTypeModalSelect />
                <div className="divider" />
                {!isOffPlan && pType === "sales" && 
                <div className="modal-filter-item building-type-select">
                  <h3 className="modal-filter-title">Completion Status</h3>
                  <div className="modal-filter-section selection-section">
                    <div className="status-blk">
                      <button onClick={() => setStatusType('')} className={statusType === '' ? "active tab-btn" : "tab-btn"}>Any</button>
                      <button onClick={() => setStatusType('completed')} className={statusType === 'completed' ? "active tab-btn" : "tab-btn"}>Ready</button>
                      <button onClick={() => setStatusType('off-plan')} className={statusType === 'off-plan' ? "active tab-btn" : "tab-btn"}>Off Plan</button>
                    </div>
                  </div>
                </div>
                }

{!isOffPlan && pType === "sales" && <div className="divider" />}
                <PriceRangeSelect />
                <div className="divider" />
                <BedroomRangeSelect />
                {isOffPlan ? (
                  <>
                    <div className="divider" />
                    <div className="modal-filter-item range-select">
                      <h3 className="modal-filter-title">Status & Developer</h3>
                      <div className="modal-filter-section">
                        <OffplanStatusSelect />
                        <DeveloperSelect />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="divider" />
                    <div className="modal-filter-item range-select area-range-select">
                      <AreaSlider />
                    </div>
                    
                  </>
                )}
                <div className="divider" />
                <AmentiesSliderModalSelect isOffPlan={isOffPlan}  />
              </>
            ) : (
              <AmentiesCheckbox isOffPlan={isOffPlan} />
            )}
            
            {!isOffPlan &&<><div className="divider" /><FurnishedCheckbox /></>}
            {/*  */}
            {!isOffPlan && <>
              <div className="divider" />
              <div className="modal-filter-item amenities-checkbox">
                <h3 className="modal-filter-title">Search by Reference Number</h3>
                <div className="d-flex">
                  <input
                    type="text"
                    placeholder={"Reference Number: e.g. PS-8435590"}
                    className={isvalidate && !crmId ? "crm-id-input er" : "crm-id-input"}
                    defaultValue={crmId}
                    onChange={(e) => { setcrmId(e.target.value); setValidate(false); }}
                  />

                  <button onClick={() => goRedirect()} className="button button-orange go-btn">Go</button>
                </div>
                {isvalidate && !crmId &&
                  <div className="error">Please enter Reference Number</div>}
              </div>
              {/* <div className="divider" /> */}
            </>}
            {/* {isCommercial ? <AreaSizeSelect /> : <BedroomSelect />} */}

          </div>


        </Modal.Body>
        {isPropertyPage && (<Modal.Footer>
          <div className="cta-section">
            <button
              className="button button-gray"
              onClick={() => {
                clearFilters()
                setIsOpen(false)
              }}
            >
              Clear Filters
            </button>
            <SearchButton onClick={() => setIsOpen(false)}>
              <span>Update</span>
            </SearchButton>
          </div>
        </Modal.Footer>)}
      </Modal> :
      <Modal
        show={isOpen}
        onHide={() => setIsOpen(false)}
        dialogClassName={clsx(
          "modal-search-filter",
          isPropertyPage && "property-modal"
        )}
        backdropClassName={clsx(
          "modal-search-filter-backdrop",
          isPropertyPage && "property-modal"
        )}
        fullscreen={isTablet}
      >
        <Modal.Header closeButton>
          <h2 className="title">{isOffPlan ? "More Filter" : "Property Search"}</h2>
        </Modal.Header>


        <FilterModalBody setIsOpen={setIsOpen} buyRent={buyRent} isOffPlan={isOffplan} />


      </Modal>
  )
}

export default FilterModal
